import { render, staticRenderFns } from "./OrderPayers.vue?vue&type=template&id=53229622&scoped=true&"
import script from "./OrderPayers.vue?vue&type=script&lang=js&"
export * from "./OrderPayers.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayers.vue?vue&type=style&index=0&id=53229622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53229622",
  null
  
)

export default component.exports